module.exports = __webpack_public_path__ + "img/bg-support.aad0ae51.jpg";